<ng-template #termsAndConditionsModal let-c="close" let-d="dismiss">
	<div id="terms-and-conditions">
		<div class="modal-header">
			<h4 class="modal-title">{{ 'terms.modal.title' | translate }}</h4>
		</div>
		<div class="modal-body">
			<b>{{ infoText | translate: { deadline: dateOfEnactment | date: 'mediumDate':null:currentLanguageCode } }}</b>
		</div>
		<div class="container">
			<cfe-terms-and-conditions
				[control]="form.get('acceptTermsCheckbox')"
				[id]="'acceptTermsOfConditions-checkbox'"
				[disabled]="false"
				[notMarkAsRequired]="false"
				[labelStyles]="{ 'font-weight': 500 }"
				[showError]="false"
			>
			</cfe-terms-and-conditions>
		</div>
		<div class="container">
			<div class="d-flex align-items-end modal-footer button-size">
				<button
					type="button"
					class="btn btn-outline-primary mr-2"
					[disabled]="form.get('acceptTermsCheckbox').value || deadlineReached ? true : false"
					(click)="c('Confirm click')"
					id="later-button"
				>
					{{ 'notificationOrConfirm.later' | translate }}
				</button>
				<cfe-spinner-button
					[value]="'notificationOrConfirm.ok' | translate"
					(clicked)="onSubmit()"
					[cssClass]="'btn btn-primary w-100'"
					[loader]="loader"
					[disabled]="form.get('acceptTermsCheckbox').value ? false : true"
					[id]="'ok-button'"
				>
				</cfe-spinner-button>
			</div>
		</div>
	</div>
</ng-template>
